<template>
<div :style="getAccordionWidth()" class="mb-2">
  <div
    v-for="(accordion, i) in dynamicList"
    :key="i"
  >
    <div :style="getAccordionBox(accordion)">
      <div
        v-b-toggle="'accordion-' + accordion.id"
        :style="getAccordionBg(accordion)"
        :id="accordion.id"
        @click="accordion.visible = !accordion.visible"
      >
        <span :style="getAccordionTextColor(accordion)">
          <component
            :is="getAccordionTitleStyle(accordion)"
          >
            <slot>
              <i class='fa fa-times' v-if="accordion.visible"/>
              <i class='fa fa-plus' v-else/>
              {{accordion.accordionTitle}}
            </slot>
          </component>
        </span>
      </div>
      <b-collapse :id="'accordion-' + accordion.id" class="accordion-content">
        <div v-html="accordion.accordionDescription"/>
      </b-collapse>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'AccordionViewSection',
  props: ['accordionList', 'accordionWidth'],
  data(){
    return {
      dynamicList: []
    }
  },
  async created(){
    await this.prepareAccordionList();
  },
  methods: {
    prepareAccordionList(){
      this.accordionList.forEach(element => {
        this.dynamicList.push({...element, visible: false});
      });
    },
    getAccordionWidth() {
      if(this.accordionWidth) {
        return this.accordionWidth ? `width: ${this.accordionWidth}%;margin: 0 auto;` : ''
      } else {
        return 'width: 100%;margin: 0 auto;'
      }
    },
    getAccordionBg(accordion) {
      return accordion.borderStyle ? `background: ${accordion.borderStyle};padding: 10px 12px 10px 18px;` : ''
    },
    getAccordionBox(accordion) {
      if(accordion.isBorder && accordion.borderStyle) {
        return `border: 2px solid ${accordion.borderStyle};margin-bottom: 1rem;`
      } else if (accordion.isBorder) {
        return `border: 2px solid #000000;margin-bottom: 1rem;padding: 10px 12px 10px 18px;`
      } else {
        return ''
      }
    },
    getAccordionTextColor(accordion) {
      return accordion.headingColor ? `color: ${accordion.headingColor};` : ''
    },
    getAccordionTitleStyle(accordion) {
      if (accordion.headingStyle) {
        return accordion.headingStyle;
      } else {
        return 'span';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.accordion-width {
  width: 100%;
  margin: 0 auto;
}
.accordion-content {
  margin: 30px;
}
</style>

